// extracted by mini-css-extract-plugin
export default {"link":"login-component_link__-6LbW"};